import { render, staticRenderFns } from "./room-registration-guests.vue?vue&type=template&id=798c0c68&"
import script from "./room-registration-guests.vue?vue&type=script&lang=ts&"
export * from "./room-registration-guests.vue?vue&type=script&lang=ts&"
import style0 from "./room-registration-guests.vue?vue&type=style&index=0&id=798c0c68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports